import React, { Component } from 'react';
import { Card, Input, Button } from 'semantic-ui-react';
import 'react-dadata/dist/react-dadata.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import './styles.css';
import PropTypes from 'prop-types';
import { getCart } from '../../views/Cart/reducer';
import { getDiscount, getDiscountFetching, getSumDiscount } from './reducer';
import { fetchApplyCoupon, removeCoupon } from './actions';

class CouponCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: {},
            coupons: {},
            inputCoupon: props.inputCoupon,
        };
    }

    componentDidMount() {
    }

    setField = (e) => this.setState({inputCoupon: e.target.value});

    applyCoupon = () => {
        const { inputCoupon } = this.state;
        const { dispatch, cart } = this.props;

        if (inputCoupon && cart) {
            dispatch(fetchApplyCoupon(inputCoupon, {cart}));
        }
    };

    handleRemoveCoupon = () => {
        const { dispatch } = this.props;
        dispatch(removeCoupon());
        this.setState({ inputCoupon: '' });
    };

    render() {
        const { coupons, sumDiscount } = this.props;
        const hasActiveCoupon = coupons && sumDiscount > 0;

        return (
            <Card centered className="coupon-card">
                <Card.Header>Есть промокоды?</Card.Header>
                <Card.Content>
                    {hasActiveCoupon && (
                        <div className="coupon-applied">
                            <div className="coupon-applied-header">Промокод применён!</div>
                            <div className="coupon-applied-discount">Скидка: {sumDiscount} ₽</div>
                            <Button
                                size="small"
                                color="red"
                                onClick={this.handleRemoveCoupon}
                                className="remove-coupon-btn"
                            >
                                Удалить промокод
                            </Button>
                        </div>
                    )}

                    <Input
                        action={{
                            color: 'blue',
                            labelPosition: 'right',
                            icon: 'hand pointer',
                            content: 'Применить',
                            onClick: this.applyCoupon,
                            disabled: hasActiveCoupon
                        }}
                        name="inputCoupon"
                        iconPosition="left"
                        placeholder="введите промокод"
                        fluid
                        className="coupon-apply-input"
                        value={this.state.inputCoupon}
                        onChange={this.setField}
                        loading={this.props.isFetching}
                        disabled={hasActiveCoupon}
                    />
                </Card.Content>
            </Card>
        );
    }
}

CouponCard.propTypes = {
    inputCoupon: PropTypes.string,
    isFetching: PropTypes.bool,
};

CouponCard.defaultProps = {
    inputCoupon: '',
    isFetching: false,
};

const mapStateToProps = state => ({
    cart: getCart(state.cart).map(obj => (
        { id: obj.id, price: obj.price, quantity: obj.quantity }
    )),
    isFetching: getDiscountFetching(state.discount),
    coupons: getDiscount(state.discount),
    sumDiscount: getSumDiscount(state.discount) || 0,
});

function mapDispatchToProps(dispatch) {
    return Object.assign({ dispatch }, bindActionCreators({}, dispatch));
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CouponCard);